import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between align-top border-b-2 mb-8 pb-8" }
const _hoisted_2 = { class: "w-1/3" }
const _hoisted_3 = { class: "text-gray-800 font-header text-xl" }
const _hoisted_4 = { class: "text-gray-600 text-sm" }
const _hoisted_5 = { class: "w-1/2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Card, {
        class: "shadow-md",
        style: {"margin-top":"0"}
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ])
  ]))
}